import { useSyncExternalStore } from 'react';
import { speakerLabelAutoHiddenStore } from '@/stores/speakerLabelAutoHiddenStore';

export function useIsNameCardAutoHidden(): boolean {
  return useSyncExternalStore(speakerLabelAutoHiddenStore.subscribe, speakerLabelAutoHiddenStore.getSnapshot);
}
